module.exports = __webpack_public_path__ + "img/fb91f94.jpg";